export function sleep(ms: number, signal?: AbortSignal) {
  return new Promise<void>((resolve, reject) => {
    if (signal?.aborted) {
      // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
      return reject(signal.reason);
    }

    const timer = setTimeout(onResolve, ms);
    signal?.addEventListener('abort', onAbort);

    function onResolve() {
      cleanup();
      resolve();
    }

    function onAbort() {
      cleanup();
      // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
      reject(signal?.reason);
    }

    function cleanup() {
      signal?.removeEventListener('abort', onAbort);
      clearTimeout(timer);
    }
  });
}
